<nz-spin [nzSpinning]="loading$ | async">
  <div class="records">
    <div class="content-wrapper">
      <nz-collapse [nzBordered]="false" [nzExpandIconPosition]="'end'">
        <nz-collapse-panel
          *ngFor="let panel of panels; let i = index"
          [nzHeader]="panel.name"
          [(nzActive)]="panel.active"
          (nzActiveChange)="onPanelChange(i, $event)"
          [nzExtra]="extraTpl">
          <ng-container *ngIf="panel.name === 'Contact Us'; else downloadList">
            <div
              class="contact-card"
              *ngFor="let card of panel.cards"
              [class.contact-card--clickable]="isLiveChatCard(card.label)"
              [attr.role]="isLiveChatCard(card.label) ? 'button' : null"
              [attr.tabindex]="isLiveChatCard(card.label) ? 0 : null"
              (click)="isLiveChatCard(card.label) && openLiveChat()"
              (keydown.enter)="isLiveChatCard(card.label) && openLiveChat()"
              (keydown.space)="onCardSpaceKeyDown($event, card.label)">
              <span class="contact-card__label">{{ card.label }}</span>
              <span class="contact-card__value">{{ card.value }}</span>
            </div>
          </ng-container>
          <ng-template #downloadList>
            <p class="collapse-content" *ngFor="let obj of panel.content">
              <button
                nz-button
                type="button"
                nzType="text"
                class="primary-text-btn"
                (click)="downloadFile(obj)">
                {{ obj.name }}
              </button>
            </p>
          </ng-template>
          <ng-template #extraTpl let-panel>
            <button
              type="button"
              nz-button
              nzType="default"
              aria-label="Settings"
              class="collapse-btn">
              <svg-icon
                [src]="
                  this.selectedPanel[i]
                    ? '/assets/icon/icon-minus.svg'
                    : '/assets/icon/icon-plus.svg'
                "
                class="icon s-12"
                aria-label="Icon"></svg-icon>
            </button>
          </ng-template>
        </nz-collapse-panel>
      </nz-collapse>
    </div>
  </div>
</nz-spin>

<!-- Button in the "extra" section of the panel -->
